import React from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Button, Grid, Drawer } from '@material-ui/core';
import SchematicDrawerHeader from 'features/wells/schematics/components/SchematicDrawerHeader';
import { formID } from 'features/wells/schematics/helpers/constants';

const SchematicDrawer = ({ children, classes, isOpen, onClose }) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <SchematicDrawerHeader
        classes={classes.padding}
        title="Add Component"
        closeDrawer={onClose}
      />
      <div className={classes.padding}>{children}</div>
      <div className={classes.footer}>
        <Grid item container justifyContent="flex-end" spacing={1}>
          <Grid item xs={3} xl={2}>
            <Button title="Cancel" variant="text" onClick={onClose}>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Button
              form={formID}
              title="Save"
              color="primary"
              variant="contained"
              type="submit"
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

const styles = (theme) => ({
  drawerPaper: {
    width: '30%',
    minWidth: 300,
    overflow: 'clip',
    background: theme.palette.background.default,
  },
  padding: {
    padding: theme.spacing(2),
  },
  footer: {
    marginTop: 'auto',
    backgroundColor: theme.palette.secondary.dark,
    padding: '16px 24px',
  },
});

export default withStyles(styles)(SchematicDrawer);
